<template>
	<el-collapse v-bind="$props" @change="$emit('update:value', $event)">
		<slot />
	</el-collapse>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsCollapse',
	props: {
		value: Array,
		accordion: Boolean,
	},
});
</script>

<style scoped lang="scss">
	.el-collapse {
		border: none;
		margin-bottom: 5px;
	}
</style>
